module.exports = __webpack_public_path__ + "img/SEARCH.611c3bca.svg";